/* global Promise */
( function( $ ) {
	var facilitiesWrapEle, formsEles;
	var currRequest = null;
	const controller = new AbortController();

	document.addEventListener( 'DOMContentLoaded', function() {
		facilitiesWrapEle = document.querySelector( '.facility-tabs__container' );
		if( !facilitiesWrapEle ) { return; }

		formsEles = facilitiesWrapEle.querySelectorAll( 'form' );

		// Do this before everything's listening
		applyUrlFilters();
		
		facilitiesWrapEle.addEventListener( 'change', function( e ) {
			if( e.target.matches( 'input, select' ) ) {
				if( e.target.parentElement.matches( '.facility-filters__sort-zip, .facility-filters__single-search' ) ) { return; }
				enforceSingleSelect( e.target, e.target.closest( 'form' ).querySelectorAll( 'input, select, textarea' ) );
				makeNewRequest.apply( e.target );
			}
		} );

		facilitiesWrapEle.addEventListener( 'click', function( e ) {
			if ( e.target.matches( '.pagination__prev a:not([tabindex="-1"]), .pagination__next a:not([tabindex="-1"])' ) ) {
				pageNav( e );
			} 
		} );
		
		// Add analytics events to clicks on the results in the rehab tab (assuming that's the first one)
		if( window.dataLayer ) {
			let panelContainer = facilitiesWrapEle.querySelector( '.facility-tabs__panel .facility-result__container' );

			panelContainer.addEventListener( 'click', function( e ) {
				if( e.target.matches( '.facility-result a:not([data-toggle="tooltip"])' ) ) {
					var result = this.closest( '.facility-result' );
					var resultSetWrap = this.closest( '.facility-result__wrap' );
					var eventType = '';
					var url = this.getAttribute( 'href' ).toLowerCase(); // what's actually populated in the attribute, not the resolved url (keep it relative)
					
					if( url.match( /https?:\/\// ) ) {
						eventType = 'facility_web_click';
					} else if( this.classList.contains( 'facility-result__contact--phone' ) ) {
						eventType = 'facility_tel_click';
					} else {
						eventType = 'facility_profile_click';
					}
	
					var pageNum = parseInt( resultSetWrap.querySelector( '.pagination__pages input:checked' ).value );
					if( isNaN( pageNum ) ) { pageNum = 1; } // if there is no pagination, fall back to page 1
	
					var dataObj = {
						'event': eventType,
						'sponsored': result.classList.contains( 'facility-result--sponsored' ),
						'page': pageNum,
						'facility_id': result.dataset.facilityid,
						'facility': ( result.querySelector( '.facility-result__title' ).textContent ).trim(),
						'city': resultSetWrap.dataset.city || null,
						'state': resultSetWrap.dataset.state || null
					};
	
					window.dataLayer.push( dataObj );
				}
			} );
		}

		formsEles.forEach( form => {
			form.addEventListener( 'reset', function() {
				setTimeout( function() { // wait a beat for the inputs to update
					// uncheck anything remaining
					form.querySelectorAll( 'input[type="checkbox"]:checked' ).forEach( function( input ) {
						input.checked = false;
					} );

					// refresh the results
					makeNewRequest.apply( form );
				}, 1 );
			} );

			form.addEventListener( 'submit', function( e ) { e.preventDefault(); } );

			updateActiveFilters( form );
		} );

		document.querySelectorAll('[data-view]').forEach(btn => {
			btn.addEventListener('click', () => {
			const hidden = document.getElementById('view-mode');
			hidden.value = btn.dataset.view;
			makeNewRequest.apply(hidden);
			});
		});

		const countEl = document.querySelector(".facility-result__count");
     const containerEl = document.querySelector(".facility-result__container");

		if (countEl && containerEl && countEl.classList.contains("move-up")) {
			containerEl.parentNode.insertBefore(countEl, containerEl);
		}
	} );

const wrapper = document.querySelector('.view-mode-wrapper');
const viewInput = document.querySelector('#view-mode');

if (wrapper && viewInput) {
wrapper.addEventListener('click', e => {
if (!e.target.matches('button')) return;


const btn = e.target;
const isActive = btn.classList.contains('is-active');


wrapper.querySelectorAll('button').forEach(b => {
b.classList.remove('is-active');
});


if (!isActive) {
btn.classList.add('is-active');
viewInput.value = btn.getAttribute('data-view');
} else {
viewInput.value = '';
}
});
}

	// https://stackoverflow.com/a/9310752/738394
	//function escapeRegExp( text ) {
	//	return text.replace( /[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&' );
	//}

	function enforceSingleSelect( input, inputs ) {
		if( !input || input.type !== 'checkbox' || !input.name || !input.checked ) { return; }
		if( input.name.toLowerCase() !== 'payments' ) { return; }

		Array.from( inputs )
			.filter( function( ele ) { return ele !== input && ele.type === 'checkbox' && ele.name === input.name; } )
			.forEach( function( ele ) { ele.checked = false; } );
	}

	function applyUrlFilters() {
  const h = window.location.hash;
  if (!h || !h.length) return;

  const pairs = h.substring(1).split('|').map(s => {
    const [k, v=''] = s.split('=');
    return [decodeURIComponent(k), decodeURIComponent(v)];
  });

  const form = [...formsEles].find(f => f.offsetWidth > 0 && f.offsetHeight > 0);
  const inputs = form.querySelectorAll('input, select, textarea');
  let updated = false;

  pairs.forEach(([key, rawVals]) => {
    const name = key.toLowerCase();
    const values = rawVals.split(',').filter(Boolean).map(v => v.toLowerCase());
	
    const matches = [...inputs].filter(el => el.name && el.name.toLowerCase() === name);

    matches.forEach(el => {
      if ((el.type === 'checkbox' || el.type === 'radio')) {
        const v = (el.value || '').toLowerCase();
        if (values.includes(v)) {
          if (el.type === 'radio') {
            [...inputs].filter(i => i.name === el.name).forEach(i => (i.checked = false));
          }
          el.checked = true;
          enforceSingleSelect( el, inputs );
          updated = true;
        }
      } else if (el.tagName.toLowerCase() === 'select') {
        const opt = [...el.options].find(o => values.includes((o.value || '').toLowerCase()));
        if (opt) { el.value = opt.value; updated = true; }
      } else {
        el.value = rawVals;
        updated = true;
      }
    });
  });

  if (updated) makeNewRequest.apply(form, [true]);
}

	function pageNav( e ) {
		e.preventDefault();
		var pagination = e.target.closest( '.pagination' );
		var pages = pagination.querySelectorAll( 'input[type="radio"]' );
		var currPage = Array.from( pages ).find( input => input.checked );
		var currPageIndex = Array.from( pages ).indexOf( currPage );

		if( pagination.querySelector( '.pagination__prev a' ) === e.target ) {
			// go backwards
			if( currPageIndex > 0 ) {
				currPage.checked = false;
				let page = pages[ currPageIndex - 1 ];
				page.checked = true;
				page.dispatchEvent( new Event( 'change', { bubbles: true } ) );
			}
		} else {
			// go forwards
			if( currPageIndex < pages.length - 1 ) {
				currPage.checked = false;
				let page = pages[ currPageIndex + 1 ];
				page.checked = true;
				page.dispatchEvent( new Event( 'change', { bubbles: true } ) );
			}
		}
	}

	function updateActiveFilters( formEle ) {
		var formActiveContainers = formEle.querySelectorAll( '.facility-filters__active-wrap' );

		var checked = formEle.querySelectorAll( 'input[type="checkbox"]:checked' );

		if( checked.length === 0 ) {
			formActiveContainers.forEach( element => {
				while( element.firstChild ) {
					element.removeChild( element.firstChild );
				}

				element.closest( '.facility-filters__active' ).classList.remove( 'facility-filters__active--active' );
			} );
		} else {
			formActiveContainers.forEach( function( container ) {
				container.querySelectorAll( 'label' ).forEach( function( label ) { // remove all filters that are no longer checked
					var checkboxId = label.getAttribute( 'for' );
					if( Array.from( checked ).filter( checkbox => checkbox.id === ( checkboxId ) ).length == 0 ) {
						container.removeChild( label );
					}
				} );
			} );
			checked.forEach( function( input ) { // ensure all that are checked are in the active area
				var checkboxId = input.id;
				var nextSibling = input.nextElementSibling;
				var checkboxText = nextSibling.tagName.toLowerCase() === 'label' ? nextSibling.textContent.trim() : '';
				formActiveContainers.forEach( function( container ) {
					if( !container.querySelectorAll( '[for="' + checkboxId + '"]' ).length ) {
						var label = document.createElement( 'label' );
						label.setAttribute( 'for', checkboxId );
						label.classList.add( 'facility-filters__active-toggle' );
						label.textContent = checkboxText;
						container.appendChild( label );
					}
				} );
			} );
			
			formActiveContainers.forEach( function( container ) {
				container.closest( '.facility-filters__active' ).classList.add( 'facility-filters__active--active' );
			} );
		}
	}

	function makeNewRequest( preventScroll ) {
		var formEle = this.closest( 'form' );
		var zipInputEle = document.querySelector( '.facility-filters__sort-zip input' );
		var resultsSet = formEle.querySelector( '.facility-result__set' );
		
		updateActiveFilters( formEle );

		if( zipInputEle ) {
			zipInputEle.disabled = true;
		}

		hideError.apply( formEle );

		const data = new FormData( formEle );
		formEle.querySelector( '.spinner' ).classList.add( 'spinner--active' );
		facilitiesWrapEle.querySelector( '.facility-result__count' ).classList.add( 'facility-result--loading' );
		
		resultsSet.textContent = '';

		if( !preventScroll ) {
			const containerEle = formEle.querySelector( '.facility-result__container' );

			containerEle.scrollIntoView( {
				behavior: 'smooth',
				block: 'start'
			} );

			containerEle.focus( {
				preventScroll: false
			} );
		}

		if( currRequest ) { controller.abort(); }
		
		var METHOD = formEle.getAttribute( 'method' );
		
		var requestOptions = {
			method: METHOD,
			headers: {
				'Content-Type': 'text/html; charset=utf-8'
			}
		};

		var fetchLink = formEle.getAttribute( 'action' );

		if( METHOD.toLowerCase() === 'get' ) {
			fetchLink += ( fetchLink.includes( '?' ) ? '&' : '?' ) + new URLSearchParams( data ).toString();
		} else {
			requestOptions.body = JSON.stringify( data );
		}

		currRequest = fetch( fetchLink, requestOptions )
			.then( ( response, rejectResponse ) => {
				if( !response.ok ) {
					return Promise.reject( rejectResponse );
				}
				return response.text();
			} )
			.then( response => {
				if ( response.length ) {
					renderResults.apply( formEle, [response] );
				} else {
					showErrorState.apply( formEle );
				}
			} )
			.catch( showErrorState ) 
			.finally( () => {
				facilitiesWrapEle.querySelector( '.facility-result__count' ).classList.remove( 'facility-result--loading' );
				formEle.querySelector( '.spinner' ).classList.remove( 'spinner--active' );
				currRequest = null;
				if( zipInputEle ) {
					zipInputEle.disabled = false;
				}
			} );
	}

$(function () {
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    });
});

	function renderResults( resultsEle ) {
		const parser = new DOMParser();
		const doc = parser.parseFromString( resultsEle, 'text/html' );
		var results = doc.body.firstChild; // The new facility-result__set

		var total = results.dataset.resultsTotal;

		var countText = facilitiesWrapEle.querySelector( '.facility-result__count' );	
		countText.querySelector( '.facility-result__total' ).textContent = total;

        countText.classList.remove('facility-result--loading');

		if( results.querySelectorAll( 'ul > li' ).length ) { // has results (organic or sponsored)
			this.querySelector( '.facility-result__set' ).replaceWith( results );
			$( this.querySelector( '[data-toggle="tooltip"]' ) ).tooltip(); // Maintaining JQuery due to bootstrap usage

			if( !total || isNaN( parseInt( total ) ) || !parseInt( total ) ) { // no organic results
				showErrorState.apply( this, ['No organic results'] );
			} else {
				hideError.apply( this );
				//countText.style.display = 'block';
			}

			document.body.dispatchEvent( new Event( 'facility-result-rendered', { bubbles: true } ) );
		} else {
			var resultSet = this.querySelector( '.facility-result__set' );
			
			while( resultSet.firstChild ) {
				resultSet.removeChild( resultSet.firstChild );
			}

			showErrorState.apply( this );
		}
	}

	function showErrorState( error ) {
		facilitiesWrapEle.querySelector( '.facility-result__count' ).display = 'none';
		facilitiesWrapEle.querySelector( '.facility-result__container' ).classList.add( 'facility-result--error' );
		
		const countEle = facilitiesWrapEle.querySelector( '.facility-result__count' );
		countEle.classList.add( 'facility-result--error' );
		
		// eslint-disable-next-line no-console
		console.warn( 'Error: ', error );
	}

	function hideError() {
		facilitiesWrapEle.querySelector( '.facility-result__container' ).classList.remove( 'facility-result--error' );
		facilitiesWrapEle.querySelector( '.facility-result__count' ).classList.remove( 'facility-result--error' );
	}

} )( jQuery );